import { render } from "./QuickEditCard.vue?vue&type=template&id=3510adb2&scoped=true"
import script from "./QuickEditCard.vue?vue&type=script&lang=js"
export * from "./QuickEditCard.vue?vue&type=script&lang=js"

import "./QuickEditCard.vue?vue&type=style&index=0&id=3510adb2&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3510adb2"]])

export default __exports__